import {
  Page,
  Document,
  PDFViewer,
  View,
  Text,
  StyleSheet,
} from "@react-pdf/renderer";
import { numberWithDecimals } from "../../utils/validate";
import { Circle } from "../../components/Animation";
import { Request } from "../../hooks/Request";
// import { Request } from "../../hooks/Request";

const styles = StyleSheet.create({
  page: {
    padding: "10px 20px",
    fontSize: 7.5,
    paddingBottom: 85,
  },
  seccion: {
    marginTop: 20,
    marginHorizontal: 30,
  },
  title: {
    fontSize: 14,
    textAlign: "right",
    marginBottom: 10,
    fontWeight: 500,
    letterSpacing: 0.5,
  },
  row: {
    flexDirection: "row",
    gap: 80,
  },
  column: {
    flex: 1,
  },
  rows: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 2,
  },
  datos: {
    flexDirection: "col",
    alignItems: "flex-end",
  },
  detalle: {
    width: 300,
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 2,
    gap: 10,
  },
  label: {
    width: 100,
    textAlign: "right",
    marginTop: 1,
    fontWeight: "semibold",
    flex:1
  },
  value: {
    flex: 1,
    wordBreak: "break-word",
    textAlign: "right",
    marginTop: 1,
    flex:2
  },
  table: {
    marginTop: 4,
    borderColor: "#000",
    borderStyle: "solid",
  },
  tableRowHeader: {
    flexDirection: "row",
    backgroundColor: "#c6c6c6",
    borderRadius: 2,
  },
  cell: {
    flex: 1,
    padding: 3,
    textAlign: "right",
    borderColor: "#000",
    borderStyle: "solid",
    fontWeight: "bold",
  },
  tableRow: {
    flexDirection: "row",
    minHeight: 24,
    borderColor: "#000",
    borderStyle: "solid",
  },
  cellRow: {
    flex: 1,
    padding: 3,
    textAlign: "right",
    fontWeight: "normal",
    alignSelf: "center",
  },
  text1: { fontWeight: "bold", marginBottom: 1, paddingLeft: 2, paddingTop: 2 },
  text2: { marginBottom: 1, paddingLeft: 2 },
});
const processDataWithSaldo = (rawData) => {
  let saldoAcumulado = 0;

  const tabla = rawData.map((item) => {
    const monto = parseFloat(item?.description3) || 0;
    const tipo = item?.description2?.toLowerCase().trim();

    if (tipo === "ingreso") {
      saldoAcumulado += monto;
    } else if (tipo === "egreso") {
      saldoAcumulado -= monto;
    }

    return {
      ...item,
      monto,
      saldo: saldoAcumulado,
    };
  });

  return { tabla, saldoTotal: saldoAcumulado }; 
};

const transformData = (data) => {
  const { tabla, saldoTotal } = processDataWithSaldo(
    data.ítemsDeConciliaciónSubDatas || []
  );

  return {
    cliente: {
      cliente: data.company.razonSocial,
      nit: data.company.nit,
      direccion: data.company.direccion,
      ciudad: data.company.ciudad,
      contacto: data.company.phone,
    },
    Importador: {
      nro: data.codigoDeInterno,
      nroCotizacion: data.nroCotizacion,
      fechaDeCotización: data.fechaDeCotización,
      tipoDeDespacho: data.tipoDeDespacho,
      a4AduanaDeDespacho: data.a4AduanaDeDespacho,
      proveedor: data.proveedor,
      nroFacturaComercial: data.nroFacturaComercial,
      piNro: data.piNro,
      nroBl: data.nroBl,
      nroDeContenedor: data.nroDeContenedor || "-",
      tipoDeCambioProforma: data.tipoDeCambioProforma,
      numero: data.codigoDeInterno || "-",
      fechaConciliacion: "-Falta-",
      hojaTrabajo: data.codigoDeInterno || "-",
      nombreBanco: "-Falta-",
      cuentaBanco: "-Falta-",
      declaracion: "-Falta-",
    },
    tabla,
    saldoTotal, 
  };
};

const listDataValues = [
  "internCode",
  "codigoDeInterno",
  "nroCotizacion",
  "modalidadDeDespacho",
  "descripciónDeLaMercancía",
  "partidaArancelaria",
  "valoresNominales",
  //
  "fechaDeCotización",
  "tipoDeDespacho",
  "a4AduanaDeDespacho",
  "proveedor",
  "nroFacturaComercial",
  "piNro",
  "nroBl",
  "tipoDeCambioProforma",
  "nroDeContenedor",

  "ítemsDeConciliación",
];

const BankDepositReconciliation = ({ procedure }) => {
  const { data, loading } = Request({
    urlApi: `/Procedure/${procedure.id}/dataValues?${listDataValues
      .map((field) => `fieldnames=${field}`)
      .join("&")}`,
  });
  console.log("🚀 ~ BankDepositReconciliation ~ data:", data);

  if (!loading) {
    return <Circle />;
  }

  return (
    <div>
      {data && (
        <PDFViewer
          style={{
            width: 900,
            height: window.innerHeight - 100,
          }}
        >
          <MyDocPDF data={transformData(data)} />
        </PDFViewer>
      )}
    </div>
  );
};
const MyDocPDF = ({ data }) => {
  return (
    <Document>
      <Page size="LETTER" style={styles.page}>
        <View style={styles.seccion}>
          <Text style={styles.title}>
            CONCILIACIÓN DE DEPOSITO{"\n"}BANCARIO
          </Text>
          <View style={{...styles.row}}>
            <View style={{ ...styles.column, marginTop: 15 }}>
              <Text
                style={{
                  ...styles.text1,
                  backgroundColor: "#F2F2F2",
                  paddingBottom: 2,
                }}
              >
                Cliente
              </Text>
              <Text style={[{ ...styles.text2, }, { height: 25 }]}>
                {data.cliente.cliente}
              </Text>
              <Text style={styles.text1}>Nit:</Text>
              <Text style={styles.text2}>{data.cliente.nit}</Text>
              <Text style={styles.text1}>Direccion:</Text>
              <Text style={styles.text2}>{data.cliente.direccion}</Text>
              <Text style={styles.text1}>Ciudad:</Text>
              <Text style={styles.text2}>{data.cliente.ciudad}</Text>
              <Text style={styles.text1}>Contacto:</Text>
              <Text style={styles.text2}>{data.cliente.contacto}</Text>
            </View>
            <View style={styles.column}>
              <View style={styles.rows}>
                <Text style={styles.label}>Numero:</Text>
                <Text style={styles.value}>{data.Importador.nro}</Text>
              </View>
              <View style={styles.rows}>
                <Text style={styles.label}>Fecha:</Text>
                <Text style={styles.value}>{data.Importador.fechaDeCotización}</Text>
              </View>
              <View style={styles.rows}>
                <Text style={styles.label}>Cotización:</Text>
                <Text style={styles.value}>{data.Importador.nroCotizacion}</Text>
              </View>
              <View style={styles.rows}>
                <Text style={styles.label}>Despacho:</Text>
                <Text style={styles.value}>{data.Importador.tipoDeDespacho}</Text>
              </View>
              <View style={styles.rows}>
                <Text style={styles.label}>Cod. de Aduana:</Text>
                <Text style={styles.value}>{data.Importador.a4AduanaDeDespacho}</Text>
              </View>
              <View style={styles.rows}>
                <Text style={styles.label}>Proveedor:</Text>
                <Text style={styles.value}>{data.Importador.proveedor}</Text>
              </View>
              <View style={styles.rows}>
                <Text style={styles.label}>N° Factura comercial:</Text>
                <Text style={styles.value}>{data.Importador.nroFacturaComercial}</Text>
              </View>
              <View style={styles.rows}>
                <Text style={styles.label}>P/I N°:</Text>
                <Text style={styles.value}>{data.Importador.piNro}</Text>
              </View>
              <View style={styles.rows}>
                <Text style={styles.label}>Bill Of Lading:</Text>
                <Text style={styles.value}>{data.Importador.nroBl}</Text>
              </View>
              <View style={styles.rows}>
                <Text style={styles.label}>Contenedor N°:</Text>
                <Text style={styles.value}>{data.Importador.nroDeContenedor}</Text>
              </View>
              <View style={styles.rows}>
                <Text style={styles.label}>T/C:</Text>
                <Text style={styles.value}>{data.Importador.tipoDeCambioProforma}</Text>
              </View>
            </View>
          </View>
        </View>

        <View style={styles.seccion}>
          <View style={styles.table}>
            <View style={styles.tableRowHeader}>
              <Text style={{ ...styles.cell, flex: 1, textAlign: "left" }}>
                Fecha
              </Text>
              <Text style={{ ...styles.cell, flex: 3, textAlign: "left" }}>
                Descripción
              </Text>
              <Text style={{ ...styles.cell, flex: 1 }}>
                Ingreso Bs. <Text style={{ fontWeight: "normal" }}>(debe)</Text>
              </Text>
              <Text style={{ ...styles.cell, flex: 1 }}>
                Egreso Bs. <Text style={{ fontWeight: "normal" }}>(haber)</Text>
              </Text>
              <Text style={{ ...styles.cell, flex: 1 }}>Saldo Bs.</Text>
            </View>
            {/* Filas */}
            {data.tabla.concat([...Array(2)]).map((item, index) => {
              const ingreso =
                item?.description2 === "ingreso"
                  ? Number(item?.description3)
                  : null;
              const egreso =
                item?.description2 === "egreso"
                  ? Number(item?.description3)
                  : null;
              return (
                <View
                  key={index}
                  style={{
                    ...styles.tableRow,
                    backgroundColor: index % 2 === 0 ? "#fff" : "#f0f0f0",
                  }}
                >
                  <Text
                    style={{ ...styles.cellRow, flex: 1, textAlign: "left" }}
                  >
                    {item?.creationDate || ""}
                  </Text>
                  <Text
                    style={{ ...styles.cellRow, flex: 3, textAlign: "left" }}
                  >
                    {item?.label || ""}
                  </Text>
                  <Text style={{ ...styles.cellRow, flex: 1 }}>
                    {ingreso ? numberWithDecimals(ingreso) : ""}
                  </Text>
                  <Text style={{ ...styles.cellRow, flex: 1 }}>
                    {egreso ? numberWithDecimals(egreso) : ""}
                  </Text>
                  <Text style={{ ...styles.cellRow, flex: 1 }}>
                    {item?.saldo ? numberWithDecimals(item.saldo) : ""}
                  </Text>
                </View>
              );
            })}
          </View>
        </View>
        <View style={{ ...styles.seccion }}>
          <View style={{ ...styles.tableRowHeader, padding: 2 }}>
            <View style={{ ...styles.cellRow, fontWeight: "bold" }}>
              <Text>Saldo a Favor:</Text>
            </View>
            <View style={{ alignItems: "flex-start", width: 80, gap: 2 }}>
              <Text>SCZPLUS S.R.L. Bs:</Text>
              <Text>Importadora Bs:</Text>
            </View>
            <View style={{ alignItems: "flex-end", width: 70, gap: 2 }}>
              <Text>{data.saldoTotal > 0 ? numberWithDecimals(data.saldoTotal): 0}</Text>
              <Text>{data.saldoTotal < 0 ? numberWithDecimals(data.saldoTotal): 0}</Text>
            </View>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default BankDepositReconciliation;
